<template>
  <div class="steps_box">
	  <ol class="nav-box">
		  <li v-for="item in active" :style="{ width: 100 / active.length + '%'}" :class="item.date?'active':item.Date !== null?'active':''">
			  <div class="textset">
				  <i :class="item.icon"></i> 
				  <div class="textDate">
					  <div>{{item.Text}}</div>
					  <div>{{item.Date}}</div>
				  </div> 
			  </div>
		  </li>
	  </ol>
  </div>
</template>

<script>
	
export default {
  props:['active'],
  data() {
    return {};
  },
  created(){
  },
  methods: {
   
  }
};
</script>

<style lang="scss" scoped>
	@import '@/assets/style/variables.scss';
	@import "@/assets/style/mixin.scss";
	/* 文字和icon排版 */
	.textset{
		margin-left: 10px;
		display: flex;
		align-items: center;
	}
	.textset i{
		font-size: 22px;
	}
	.textDate{
		margin-left:10px;
	}
	.textDate div{
		font-size: 12px;
		line-height: 16px;
	}
	.steps_box{
		margin: 20px 0 28px 0;
	}
	/* 底部 */
	.nav-box{
	        height:40px;
	        line-height:40px;
	        list-style: none;
	        padding:0;
	        display:flex;
	        font-size:12px;
	        overflow: hidden;
	    }
	
	    .nav-box li{
	        padding:0 10px 0 10px;
	        margin-right: 32px;
	        white-space: nowrap;
	        position:relative;
	        color:#019fe9;
	        @include bg-color(stepsColor);
	    }
	
	    /* 三角 */
	    .nav-box li:before,.nav-box li:after{
	        content:'';
	        position:absolute;
	        width: 0;
	        height: 0;
	    }
	    .nav-box li:before{
	        right: -22px;
			border: solid transparent;
			border-width: 20px 0 20px 22px;
	        @include border_left_color(stepsColor);
	        z-index:2;
	    }
	    /* 白线 */
	    .nav-box li:after{
	        top: -3px;
	        left: -26px;
	        border-style: solid;
			@include border_color(stepsColor);
	        border-width: 23px 0 23px 26px;
	        border-left-color: transparent;
	        z-index: 1;
	    }
	    .nav-box .active{
	        color: #fff !important;
	        background:#248AFD !important;
	    }
	
	    .nav-box .active ~ li{
	        @include text-color(stepsfzColor);
	        @include bg-color(stepsColor);
	    }
	    .nav-box .active:before{
	        border-left-color:#248AFD !important;
	    }
	    .nav-box .active:after{
	        border-color: #248AFD !important;
	        border-left-color: transparent !important;
	    }
	    .nav-box .active ~ li:before{
	        // border-left-color:#3D4049;
			@include border_left_color(stepsColor);
	    } 
	    .nav-box .active ~ li:after{
	        @include border_color(stepsColor);
	        border-left-color: transparent !important;
	    }
</style>